import {ReactNode, useState} from 'react';

import {assignSafely, getSafely} from 'shared/web';

import {
  ChartToolbarHighlight,
  ChartToolbarHighlights,
  defaultChartToolbarHighlights,
} from '../types/ChartToolbarHighlight';
import {
  ChartToolbarHighlightMode,
  defaultChartToolbarHighlightMode,
} from '../types/ChartToolbarHighlightMode';
import {ExtendedStatisticsCar} from '../types/ExtendedStatisticsCar';
import {getStatisticsChartSellerOptions} from '../utils/getStatisticsChartSellerOptions';
import {hasActiveChartToolbarFilters} from '../utils/hasActiveChartToolbarHighlights';
import {ChartToolbarContext} from './ChartToolbarContext';

interface ChartToolbarProviderProps {
  children: ReactNode;
  data: ExtendedStatisticsCar[];
}

export function ChartToolbarProvider(props: ChartToolbarProviderProps) {
  const [highlights, setHighlights] = useState<ChartToolbarHighlights>(
    defaultChartToolbarHighlights
  );
  const [highlightMode, setHighlightMode] = useState<ChartToolbarHighlightMode>(
    defaultChartToolbarHighlightMode
  );
  const [selectedSellerId, setSelectedSellerId] = useState<string | null>(null);

  const availableSellerIds = getStatisticsChartSellerOptions(props.data).map(
    (seller) => seller.value
  );
  const effectiveSelectedSellerId =
    selectedSellerId !== null && availableSellerIds.includes(selectedSellerId)
      ? selectedSellerId
      : null;
  const isHighlightModeActive = hasActiveChartToolbarFilters(highlights, effectiveSelectedSellerId);
  const effectiveHighlightMode: ChartToolbarHighlightMode = isHighlightModeActive
    ? highlightMode
    : 'all';

  const toggleHighlight = (highlight: ChartToolbarHighlight) => {
    setHighlights((current) =>
      assignSafely({...current}, highlight, !getSafely(current, highlight, false))
    );
  };

  const isHighlightEnabled = (highlight: ChartToolbarHighlight) =>
    getSafely(highlights, highlight, false);

  return (
    <ChartToolbarContext.Provider
      value={{
        highlights,
        highlightMode,
        effectiveHighlightMode,
        selectedSellerId: effectiveSelectedSellerId,
        setHighlightMode,
        setSelectedSellerId,
        toggleHighlight,
        isHighlightEnabled,
      }}
    >
      {props.children}
    </ChartToolbarContext.Provider>
  );
}
